import { styled } from "@mui/material";
import { BasicBox } from "../styles";

export const FavouriteCON = styled(BasicBox)`
  max-width: 100%;
`;